import _sfc_main from "./index81.js";
/* empty css        */
import _export_sfc from "./index63.js";
const ReceiptCreditNoteLocalizationEn = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-89d247dc"]]);
export {
  ReceiptCreditNoteLocalizationEn as default
};
//# sourceMappingURL=index26.js.map
